module.exports = __webpack_public_path__ + "img/liked-shaded-blue.4ac41dd1.svg";